export default __webpack_public_path__ + "static/media/kw.b4dfc5c7.jpg";